import React from 'react';
import { func, string } from 'prop-types';
import { Button } from '@thd-olt-component-react/core-ui';
import { params, string as stringType, useLazyDataModel } from '@thd-nucleus/data-sources';
import { LIST_SHAPE } from '../helpers';

export const DeleteListButton = ({ listId, onClick, onDelete }) => {
  const [submitDeleteList, deleteResponse] = useLazyDataModel('deleteList', {
    variables: {
      id: listId
    },
    context: { withAuth: true }
  });

  const onListDelete = async () => {
    if (onClick) {
      onClick();
    }
    const { data, errors } = await submitDeleteList();
    if (data?.deleteList && !errors) {
      onDelete({ listId });
    }
  };

  return (
    <Button
      type="button"
      disabled={!listId || deleteResponse?.loading}
      onClick={onListDelete}
      dark
      outline
    >
      Delete List
    </Button>
  );
};

DeleteListButton.displayName = 'ListFormsDeleteListButton';

DeleteListButton.propTypes = {
  listId: string.isRequired,
  onClick: func,
  onDelete: func.isRequired
};

DeleteListButton.defaultProps = {
  onClick: null
};

DeleteListButton.dataModel = {
  deleteList: params({
    id: stringType().isRequired()
  }).mutation().shape(LIST_SHAPE)
};
